import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

import { IonItem, IonSelect, IonSelectOption } from '@ionic/vue';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
//Interfaces & Enums
import { ImmobilieStatus } from '@/models/immobilie/interfaces/IImmobilie';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusFilter',
  props: {
  options: { type: Array as PropType<Array<{ label: string, value: ImmobilieStatus }>>, required: true },
  selectedStatuses: { type: Array as PropType<Array<{ label: string, value: ImmobilieStatus }>>, required: false },
    uiMode: { type: String, required: true }, 
},
  emits: [
  "update:statusFilter"
],
  setup(__props, { emit }) {

const props = __props;




//Data
const { t } = useI18n({ useScope: "global" });

//Methods
function onChanged(e: any) {
  emit('update:statusFilter', e.detail.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    class: _normalizeClass({ statusFilterButton: __props.uiMode === 'propertyList', mapFilterButton: __props.uiMode === 'map' }),
    lines: "none"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSelect), {
        interface: "popover",
        placeholder: _unref(t)('statusFilter.placeholder'),
        multiple: true,
        value: __props.selectedStatuses,
        class: "dynamic-width-select",
        onIonChange: onChanged
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (item) => {
            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
              key: item.value,
              value: item.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["placeholder", "value"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})